// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Home from "./pages/Home";
import Capture from "./pages/Capture";
import Device from "./pages/Device";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import GetPhoto from "./pages/GetPhoto/GetPhoto";
import SpinWin from "./pages/SpinWin";
import ScrollToTop from "./components/ScrollTop/scrollTop";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <Router>
      <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/TryNow" element={<Capture />} />
        <Route path="/Device" element={<Device />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/Getphoto" element={<GetPhoto />} />
        <Route path="/SpinWin" element={<SpinWin />} />
      </Routes>
    </Router>
  );
};

export default App;
